import styled from "styled-components";

import { BackgroudPlayerContainer } from "pages/[tenant]/browse/components/Vignette/components/BackgroudPlayerContent/styles";

import { VideoPlayerContainer } from "shared/components/atoms/VideoPlayer/styles";

export const VignetteContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  transition: 0.4s all;

  :has(.alice-carousel) {
    .alice-carousel {
      margin-top: 0;
    }
  }

  .alice-carousel__dots li {
    pointer-events: none;
  }

  .alice-carousel__wrapper,
  .billboard-presentation-container .background-image,
  .content {
    max-height: 85vh;
  }

  .alice-carousel__dots-item {
    background-color: #ffffff40;
    transition: 0.3s all;

    &.__active {
      background-color: #ffffff;
    }
  }

  .alice-carousel__next-btn,
  .alice-carousel__prev-btn {
    opacity: 0.3;

    :hover {
      opacity: 1;
    }
    svg {
      visibility: visible;
      width: 36px;
      height: 36px;
    }
  }

  .alice-carousel__dots {
    margin-top: 0;
  }

  position: relative;
  img {
    object-fit: cover;
  }
  z-index: 0;

  .background-linear-gradient {
    height: 100%;
    width: 100%;
    left: 0;
    position: absolute;
    transition: all 300ms ease-in-out;
    top: 0;

    z-index: 1;

    background: linear-gradient(
        72.29deg,
        rgba(1, 1, 1, 0.25) 34.74%,
        rgba(1, 1, 1, 0) 67.56%
      ),
      linear-gradient(179.59deg, rgba(1, 1, 1, 0) 22.09%, #010101 94.8%),
      linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0) 14.4%),
      linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
  }

  > .background-linear-gradient {
    width: 100%;
  }

  ${BackgroudPlayerContainer}, ${VideoPlayerContainer} {
    aspect-ratio: 16/9;
  }

  @media (max-width: 768px) {
    min-height: 500px;
  }
`;
